export const THEMES_REQUESTED = 'zola/wedding/website/theme/THEMES_REQUESTED';
export const THEMES_RECEIVED = 'zola/wedding/website/theme/THEMES_RECEIVED';
export const THEMES_RESET = 'zola/wedding/website/theme/THEMES_RESET';
export const THEME_REQUESTED = 'zola/wedding/website/theme/THEME_REQUESTED';
export const THEME_RECEIVED = 'zola/wedding/website/theme/THEME_RECEIVED';



// WEBPACK FOOTER //
// ./src/actions/types/website/ThemeActionTypes.js